
export const IS_SALESFORCE_RECORD_FORM_OPEN = 'IS_SALESFORCE_RECORD_FORM_OPEN';
export const SET_SALESFORCE_RECORD_OBJECT_API_NAME = 'SET_SALESFORCE_RECORD_OBJECT_API_NAME';
export const SET_CACHED_OBJECTS = 'SET_CACHED_OBJECTS';
export const SET_SALESFORCE_RECORD_REDIRECT_LINK = 'SET_SALESFORCE_RECORD_REDIRECT_LINK';
export const SET_SALESFORCE_RECORD_TOOLTIP_CONTENT = 'SET_SALESFORCE_RECORD_TOOLTIP_CONTENT';


export const setIsSalesforceRecordFormOpen = (value) => ({
  type: IS_SALESFORCE_RECORD_FORM_OPEN,
  payload: value,
});

export const setSalesforceRecordObjectApiName = (apiName) => ({
  type: SET_SALESFORCE_RECORD_OBJECT_API_NAME,
  apiName,
});

export const setCachedObjectFieldSets = (objects) => ({
  type: SET_CACHED_OBJECTS,
  objects,
});

export const setSalesforceRecordRedirectLink = (redirectLink) => ({
  type: SET_SALESFORCE_RECORD_REDIRECT_LINK,
  redirectLink,
});

export const setSalesforceRecordTooltipContent = (tooltipContent) => ({
  type: SET_SALESFORCE_RECORD_TOOLTIP_CONTENT,
  tooltipContent,
});
